import axios from 'axios';
import { getValidToken } from '@/providers/auth/keycloak';
import { reportError, suppressError } from '@/providers/error-boundary/error-bus';

const request = axios.create();

request.interceptors.request.use(
	async (config) => {
		const token = await getValidToken();
		if (token) {
			config.headers.set('Authorization', `Bearer ${token}`);
		}
		return config;
	},
	// eșec ÎNAINTE de a pleca cererea (ex. pregătirea token-ului) — tot eroare BE-flow
	// e; intră în pipeline ca orice request eșuat (CTZ-2756: nicio cale nu îl ocolește)
	(error) => {
		reportError(error);
		return Promise.reject(error);
	}
);

request.interceptors.response.use(
	(response) => response,
	(error) => {
		// Cereri anulate (AbortController / navigare / debounce) — nu sunt erori; le
		// suprimăm ca nici `unhandledrejection` să nu le raporteze ulterior.
		if (axios.isCancel(error)) {
			suppressError(error);
			return Promise.reject(error);
		}
		if (error.response?.status === 401) {
			// Sesiune expirată / neautentificat: NU afișăm eroare brută — emitem evenimentul,
			// iar AuthProvider ridică modala de expirare. Return early ca mesajul din corpul
			// răspunsului să NU ajungă în toast (altfel apărea „eroarea" de expirare).
			// Excepția pipeline-ului (CTZ-2751): suprimăm, nu raportăm generic.
			suppressError(error);
			window.dispatchEvent(
				new CustomEvent('unauthenticated', {
					detail: {
						message: 'Utilizatore neautentificat'
					}
				})
			);
			return Promise.reject(error);
		}
		// (Vechile CustomEvents per-status — forbidden/notfound/badrequest/conflict/
		// internalservererror — au fost eliminate: nu aveau niciun ascultător, iar
		// clasificarea pe statusuri o face acum normalizatorul pipeline-ului.)
		if (!error.response) {
			const networkError = error as Record<string, unknown>;
			networkError.isNetworkError = true;
		}
		// Pipeline-ul global de erori (CTZ-2756): ORICE request eșuat (4xx/5xx/rețea/
		// timeout) devine o intrare normalizată — indiferent dacă apelantul îl prinde în
		// try/catch (înainte, erorile prinse de hook-uri nu ajungeau niciodată în dialog).
		// Toast-ul categorisit îl emite provider-ul de erori (CTZ-2757) — vechile
		// notify.error de aici („Eroare de server!", „Eroare conectiune!", data.message)
		// au fost eliminate ca să nu dubleze toast-ul pipeline-ului.
		// Excepții (mai sus, cu return early): 401 → modala de sesiune; cereri anulate.
		reportError(error);
		return Promise.reject(error);
	}
);

export default request;
